<mat-tab-group>
  <mat-tab label="Today"> Content 1
  <button mat-raised-button (click)="click()">
    <mat-icon>switch</mat-icon>
    switch theme
  </button>
  </mat-tab>
  <mat-tab label="Notifications"> Content 2</mat-tab>
</mat-tab-group>
